import React from 'react';
import { Link } from 'react-router-dom';
import { StorageUtil } from '../utils/storage';

const FixedHome = () => {
  const showNavigation = StorageUtil.getItem('showNavigation');

  if (showNavigation) {
    return (
      <Link
        to="/navigation"
        style={{
          position: 'fixed',
          right: 0,
          bottom: 0,
          padding: '5px 10px',
          border: '1px solid black',
          zIndex: 100,
        }}
      >
        Nav
      </Link>
    );
  }

  StorageUtil.setItem('showNavigation', '');

  return null;
};

export default FixedHome;
